import { ImageLoaderProps } from "next/image";

export function getImageLoadingStrategy(isAboveFold: boolean, isCritical: boolean, isHero: boolean): ImageLoaderProps['loading'] {
  if (isCritical || isHero || isAboveFold) {
    return "eager";
  }
  return "lazy";
}

export function getImageQuality(isHero: boolean, isThumbnail: boolean): number {
  if (isHero) return 90;
  if (isThumbnail) return 75;
  return 85; // Default quality
}

export function getImageSizes(breakpoint: "mobile" | "tablet" | "desktop" | "full"): string {
  switch (breakpoint) {
    case "mobile":
      return "(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw";
    case "tablet":
      return "(max-width: 1024px) 100vw, (max-width: 1440px) 50vw, 33vw";
    case "desktop":
      return "(min-width: 1025px) 50vw, 33vw";
    case "full":
      return "100vw";
    default:
      return "(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw";
  }
}
